import Vue from 'vue';
import Vuex from 'vuex';
import global from './modules/global';
import config from './modules/config';
import languages from './modules/languages';
import translations from './modules/translations';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    config,
    languages,
    translations,
  },
});
